import { render, staticRenderFns } from "./SelectDepartmentForRole.vue?vue&type=template&id=31ce1e54&"
import script from "./SelectDepartmentForRole.vue?vue&type=script&lang=js&"
export * from "./SelectDepartmentForRole.vue?vue&type=script&lang=js&"
import style0 from "./SelectDepartmentForRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports